module.exports = __webpack_public_path__ + "static/media/CR.5727d806.png";